export default [
  {
    component: () => import('../pages/messages-index.vue'),
    name: 'messaging.index',
    path: '/:slug/messaging',
  },
  {
    component: () => import('../pages/messages-new.vue'),
    name: 'messaging.new',
    path: '/:slug/messaging/new',
  },
  {
    component: () => import('../pages/messages-show.vue'),
    name: 'messaging.show',
    path: '/:slug/messaging/:id',
  },
]
